module.exports = __webpack_public_path__ + "static/media/mht_790_manitou_004.e1d16af5.png";